import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ErrorService } from '../../../error';
import { WorkLocationModel } from './types';
import { catchError } from 'rxjs/operators';
import { CrudType } from '../../../service/message/types';
import { MessageService } from '../../../service/message/message.service';

@Injectable({
  providedIn: 'root',
})
export class WorkLocationApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<WorkLocationModel> => {
    let url = this.formatUrl([id.toString()]);
    return this.httpClient.get<WorkLocationModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  createInstance = (): Observable<WorkLocationModel> => {
    let url = this.formatUrl(['create']);
    return this.httpClient.get<WorkLocationModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  add = (workLocationModel: WorkLocationModel): Observable<WorkLocationModel> => {
    let url = this.formatUrl([]);
    return this.httpClient
      .post<WorkLocationModel>(url, workLocationModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  update = (
    workLocationModel: WorkLocationModel,
  ): Observable<WorkLocationModel> => {
    let url = this.formatUrl([workLocationModel.id.toString()]);
    return this.httpClient
      .put<WorkLocationModel>(url, workLocationModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  delete = (id: number): Observable<boolean> => {
    let url = this.formatUrl([id.toString()]);
    return this.httpClient.delete<boolean>(url, { observe: 'response' }).pipe(
      this.messageService.checkStatusCustomOperator(CrudType.delete),
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.workLocation.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
